import React from "react";
import columns from "../../../../../react-table/helpers/columns";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";
import ExternalLink from "../../../../common/components/ExternalLink";
import config from "../../../../../../core/config/configureSettings";

export const getDetailsTabNavOptions = (rowInfo) =>
  rowInfo && rowInfo.row
    ? {
        reportId: ReportDefinitions.ITEM_OVERVIEW_DETAILS_200.id,
        mainReportId: ReportDefinitions.ITEM_OVERVIEW_V2_201.id,
        requestParams: {
          itemId: rowInfo.row["itemId"],
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};

export default (data) => {
  const { TextColumn, DateTimeColumn, NumberColumn, NavigationColumn } =
    columns(data);

  class ExternalEntryDateLinkColumn {
    constructor(column) {
      Object.assign(this, column);
      this.Cell = (row) => {
        const entryDateValue = row.value;
        const itemId = row.original?.itemId;

        const dateTimeColumn = new DateTimeColumn("temp", "temp");
        const formattedDate = dateTimeColumn.Cell
          ? dateTimeColumn.Cell(row)
          : entryDateValue;

        const path = `/en/item/${itemId}`;
        const { atatSystem } = config.applications;

        return React.createElement(ExternalLink, {
          host: atatSystem,
          label: formattedDate,
          path,
        });
      };
    }
  }

  return [
    {
      Header: "",
      columns: [
        new TextColumn("Country from", "countryFrom"),
        new TextColumn("Country to", "countryTo"),
        new NavigationColumn(
          new TextColumn("Item ID", "itemId"),
          getDetailsTabNavOptions
        ),
        new ExternalEntryDateLinkColumn(
          new DateTimeColumn("Entry date", "entryDate")
        ),
        new TextColumn("Outw OE", "outwardOE"),
        new TextColumn("Inw OE", "inwardOE"),
        new TextColumn("Out to transit", "outToTransit"),
        new TextColumn("Return", "returnn"),
        new TextColumn("Transit through", "transitThrough"),
        new TextColumn("Delivery office", "deliveryOffice"),
        new DateTimeColumn("E2E start scan", "e2eStartScan"),
        new DateTimeColumn("Leg 2 start scan", "leg2StartScan"),
        new DateTimeColumn("Leg 3 start scan", "leg3StartScan"),
        new DateTimeColumn("E2E stop scan", "e2eStopScan"),
        new TextColumn("E2E OPS", "e2eOps"),
        new TextColumn("E2E business", "e2eBusiness"),
        new TextColumn("E2E business excl. customs", "e2eBusinessExclCustoms"),
        new NumberColumn("Days in customs", "daysInCustoms"),
        new NumberColumn("Leg 1", "leg1"),
        new NumberColumn("Leg 2", "leg2"),
        new NumberColumn("Leg 3", "leg3"),
        new TextColumn("Leg 3 intern.", "leg3Intern"),
        new TextColumn("Leg 3 domest.", "leg3Domest"),
        new TextColumn("Current status", "currentStatus"),
        new DateTimeColumn("Current status data time", "currentStatusDataTime"),
        new TextColumn("Despatch ID", "despatchId"),
        new TextColumn("Receptacle ID", "receptacleId"),
        new TextColumn("Mail subclass", "mailSubclass"),
        new TextColumn("Destination location", "destinationLocation"),
        new NumberColumn("Entry week", "entryWeek"),
        new NumberColumn("Entry month", "entryMonth"),
        new TextColumn("Party name", "partyName"),
        new TextColumn("Party identifier", "partyIdentifier"),
        new TextColumn("Operator from", "operatorFrom"),
        new TextColumn("Operator to", "operatorTo"),
        new TextColumn("IMPC from", "impcFrom"),
        new TextColumn("IMPC to", "impcTo"),
      ],
    },
  ];
};
